// ---------------------------------------------------------------------------
// Financeiro · Contas bancárias & credenciais — enums de exibição (handoff 0079).
//
// Espelha os enums do backend. Toda tradução enum → label pt-BR vive aqui, para
// não duplicar `switch` por tela.
// ---------------------------------------------------------------------------

// Situação da conta bancária.
export const BANK_ACCOUNT_STATUS_LABELS = {
   active: 'Ativa',
   inactive: 'Inativa',
};

// Tipo de conta (pode vir null).
export const ACCOUNT_TYPE_LABELS = {
   checking: 'Corrente',
   savings: 'Poupança',
};

export const ACCOUNT_TYPE_OPTIONS = [
   { value: '', label: 'Não informado' },
   { value: 'checking', label: 'Corrente' },
   { value: 'savings', label: 'Poupança' },
];

// Tipo da chave PIX (pode vir null).
export const PIX_KEY_TYPE_LABELS = {
   cpf: 'CPF',
   cnpj: 'CNPJ',
   email: 'E-mail',
   phone: 'Telefone',
   random: 'Aleatória',
};

export const PIX_KEY_TYPE_OPTIONS = [
   { value: '', label: 'Não informado' },
   { value: 'cpf', label: 'CPF' },
   { value: 'cnpj', label: 'CNPJ' },
   { value: 'email', label: 'E-mail' },
   { value: 'phone', label: 'Telefone' },
   { value: 'random', label: 'Aleatória' },
];

// Ambiente da credencial. Produção é o que fatura de verdade — por isso ganha
// destaque visual (âmbar) e sandbox fica neutro.
export const ENVIRONMENT_LABELS = {
   sandbox: 'Sandbox',
   production: 'Produção',
};

export const ENVIRONMENT_OPTIONS = [
   { value: 'sandbox', label: 'Sandbox (testes)' },
   { value: 'production', label: 'Produção' },
];

// Situação da chave.
export const KEY_STATUS_LABELS = {
   active: 'Ativa',
   revoked: 'Revogada',
};

// Provedor — hoje só existe a ASAAS; o campo já é enviado para não precisar de
// migração de contrato quando entrar o segundo.
export const DEFAULT_PROVIDER = 'asaas';

export const PROVIDER_LABELS = {
   asaas: 'ASAAS',
};
